module.exports = ("npm");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@dp/dpapp/lib/type.js
// module id = 0s5k
// module chunks = 0